import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { device, fluidType, priceFormatted } from '../../../utils/helpers'

const Header = styled.div`
  display: flex;
  justify-content: center;
  padding: 22px 0;
  background-color: ${props => props.selected ? props.theme.color.hoverPrimary : '#999999'};
  color: #fff;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 18px;

  @media ${device.tablet} {
    font-size: 14px;
    padding: 1.3541666666666667vw 0;
  }

  @media ${device.laptop} {
    font-size: 1.25vw;
  }
  ${'' /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '18px',
      '24px'
    )
};

  @media ${device.laptop} {
    font-size: 16px;
    padding: 20px 0;
  }

  @media ${device.laptopL} {
    font-size: 20px;
    padding: 22px 0;
  }

  @media (min-width: 1770px) {
    padding: 26px 0;
    font-size: 24px;
  } */}
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 160px;
  margin-bottom: 12px;
  margin: 0 10px;
  border: 5px solid ${props => props.selected ? props.theme.color.hoverPrimary : 'transparent'};
  cursor: pointer;

  @media ${device.tablet} {
    width: 10.416666666666668vw;
    margin: 0;
  }

  ${'' /* @media ${device.laptop} {
    width: 96px;
    margin: 0;
  }

  @media ${device.laptopM} {
    width: 115px;
  }

  @media ${device.laptopL} {
    width: 150px;
  }

  @media (min-width: 1770px) {
    width: 200px;
  } */}

  &:hover {
    border: 5px solid ${props => props.theme.color.hoverPrimary};
  }

  &:hover ${Header} {
    background-color: ${props => props.theme.color.hoverPrimary};
  }
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  background: #e2e2e2;
  justify-content: center;
  text-align: center;
  padding-bottom: 10px;

  @media ${device.tablet} {
    padding-bottom: 0.5208333333333334vw;
  }
`

const Price = styled.div`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  padding: 20px 0;
  font-size: 28px;

  @media ${device.tablet} {
    font-size: 1.875vw;
  ${''/* padding: 30px 0; */}
    padding: 1.5625vw 0;
  }

  ${'' /* @media ${device.laptop} {
    font-size: 22px;
    padding: 12px 0;
  }

  @media ${device.laptopL} {
    font-size: 28px;
    padding: 20px 0;
  }

  @media (min-width: 1770px) {
    padding: 35px 0;
  } */}
`

const InfoWrapper = styled.div`
  padding-bottom: 15px;
  line-height: 1em;

  @media ${device.laptop} {
    padding-bottom: 0.8333333333333334vw;
    line-height: 1.0416666666666667vw;
  }

  ${'' /* @media (min-width: 1770px) {
    padding-bottom: 16px;
    line-height: 1.25em;
  }

  @media ${device.laptop} {
    padding-bottom: 12px;
    line-height: 1em;
  } */}
`

const InfoHeader = styled.div`
  font-family: 'BarlowSemiBold';
  text-transform: uppercase;
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '10px',
      '18px'
    )
};

  @media ${device.laptop} {
    font-size: 10px;
  }

  @media ${device.laptopL} {
    font-size: 14px;
  }

  @media (min-width: 1770px) {
    ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '10px',
      '18px'
    )
};
  }
`

const InfoValue = styled.div`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '16px',
      '18px'
    )
};

  @media ${device.tablet} {
    font-size: 11px;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }

  @media ${device.laptopL} {
    font-size: 16px;
  }

  @media (min-width: 1770px) {
    padding-top: 8px;
    font-size: 18px;
  }
`

const Info = ({ heading, value }) => (
  <InfoWrapper>
    <InfoHeader>{heading}</InfoHeader>
    <InfoValue>{value}</InfoValue>
  </InfoWrapper>
)

const DurationCard = ({ duration, price, total, tax, selected, ...props }) => {
  return (
    <Wrapper selected={selected} {...props}>
      <Header selected={selected}>
        {duration}
      </Header>
      <Body>
        <Price>{priceFormatted(price)}</Price>
        <Info
          heading='Tot Netto'
          value={priceFormatted(total)}
        />
        <Info
          heading='IVA 22.00%'
          value={priceFormatted(tax)}
        />
      </Body>
    </Wrapper>
  )
}

DurationCard.propTypes = {
  /**
   * Duration of the Package
   */
  duration: PropTypes.string.isRequired,
  /**
   * Price of duration
   */
  price: PropTypes.number.isRequired,
  /**
   * Net Total price
   */
  total: PropTypes.number.isRequired,
  /**
   * Tax price
   */
  tax: PropTypes.number.isRequired
}

export default DurationCard



// WEBPACK FOOTER //
// ./src/components/Calculator/Card/DurationCard.js